import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/context/ToastContext";
import { StatusPill } from "@/components/patterns";

/** Shows that a lead or contact asked not to be called; a Sales Head or admin can allow calls again */
export function DoNotCallBadge({ type, id, flagged }: { type: "LEAD" | "CONTACT"; id: string; flagged?: boolean }) {
  const { hasPermission } = useAuth();
  const { success, error } = useToast();
  const [cleared, setCleared] = useState(false);
  if (!flagged || cleared) return null;
  const allow = async () => {
    try {
      await api.post(`/api/Call/AllowCalls/${type}/${id}`, {});
      setCleared(true);
      success("Calls allowed again", "They can be called from the CRM.");
    } catch (e: any) {
      error("Couldn't change it", e?.message || "Try again");
    }
  };
  return (
    <>
      <StatusPill tone="danger">Do not call</StatusPill>
      {hasPermission("call.recording") && (
        <button type="button" onClick={allow} className="text-xs text-primary hover:underline">Allow calls again</button>
      )}
    </>
  );
}
